import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISatinAlimDokumu_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISatinAlimDokumu_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetInvoicePurchaseVendorCharTotal: any[];
  GetInvoicePurchaseVendorCharTotal_dummy: any[];
}

export class SatinAlimDokumu_ScreenBase extends React.PureComponent<
  ISatinAlimDokumu_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "1e6741c9-d549-4346-8778-b7c6864aef17",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 641838, PropertyName: "value", Value: "Satın Alım Dökümü" },
        { Id: 857553, PropertyName: "value", Value: "Satın Alım Miktar" },
        { Id: 648920, PropertyName: "value", Value: "Satın Alım Toplam Tutar" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetInvoicePurchaseVendorCharTotal: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("satinalimdokumu", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SatinAlimDokumuPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("satinalimdokumu", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("satinalimdokumu", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SatinAlimDokumuPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SatinAlimDokumuPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatinAlimDokumu/SatinAlimDokumuPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.satinalimdokumu_765071_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.satinalimdokumu_20441_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatinAlimDokumuPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatinAlimDokumuPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satinalimdokumu_765071_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.satinalimdokumu_20441_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SatinAlimDokumuComponent_822847_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SatinAlimDokumuPageInit();
    }
  }
}
